// frontend/src/api/workflowChecklistAdmin.js
// Project: Vision ANPR by Castle Traffic Ltd
// Author: Leon du Plooy - Castle Traffic Ltd - Copyright 2026
// Updated: 2026-10-13 15:05 BST
// Change Log:
//   2026-10-13 15:05 BST - Added checklist authoring API client.
import axiosInstance from "./axiosInstance";
const base=(t,v)=>`/workflow-templates/${t}/versions/${v}/checklists`;
export async function listWorkflowTemplateChecklists(t,v){const {data}=await axiosInstance.get(base(t,v),{baseURL:"/api"});return data;}
export async function createWorkflowTemplateChecklist(t,v,p){const {data}=await axiosInstance.post(base(t,v),p,{baseURL:"/api"});return data;}
export async function updateWorkflowTemplateChecklist(t,v,c,p){const {data}=await axiosInstance.put(`${base(t,v)}/${c}`,p,{baseURL:"/api"});return data;}
export async function setWorkflowTemplateChecklistSteps(t,v,c,stepIds){const {data}=await axiosInstance.put(`${base(t,v)}/${c}/steps`,{step_ids:stepIds},{baseURL:"/api"});return data;}
export async function deleteWorkflowTemplateChecklist(t,v,c){const {data}=await axiosInstance.delete(`${base(t,v)}/${c}`,{baseURL:"/api"});return data;}
